import superagent from 'superagent';

import { backendUrl } from '@helpers/consts';

const firstDefined = (...values) => values.find(
  value => value !== undefined && value !== null && value !== ''
);

const asQuantity = value => {
  const quantity = Number(value);
  return Number.isFinite(quantity) ? quantity : 0;
};

export const normalizeAllocationRow = (row = {}) => {
  const order = row.order || {};
  const orderType = String(firstDefined(row.orderType, order.type, '')).toLowerCase();
  const isCorporate = Boolean(
    firstDefined(row.isCorporate, order.isCorporate, false)
    || orderType === 'corporate'
    || orderType === 'corp'
  );
  const orderId = String(firstDefined(row.orderId, order._id, order.id) || '');
  return {
    id: String(firstDefined(
      row.id,
      row._id,
      row.lineItemId,
      `${orderId}-${row.sku || 'unknown'}`
    ) || `${orderId}-${row.sku || 'unknown'}`),
    orderId,
    orderName: String(firstDefined(row.orderName, order.name, '-')),
    orderPath: firstDefined(
      row.orderPath,
      orderId ? `${isCorporate ? '/corp-orders' : '/orders'}/${orderId}` : undefined
    ),
    locationCode: String(firstDefined(
      row.locationCode,
      row.inventoryReservationLocationCode,
      order.locationCode,
      asQuantity(firstDefined(row.unallocatedQuantity, 0)) > 0 ? 'None' : '',
      ''
    ) || ''),
    locationName: String(firstDefined(row.locationName, row.location?.display_name, '') || ''),
    sku: String(firstDefined(row.sku, row.lineItemSku, '-')),
    reservedQuantity: asQuantity(firstDefined(
      row.reservedQuantity,
      row.inventoryReservationQuantity,
      0
    )),
    unallocatedQuantity: asQuantity(firstDefined(row.unallocatedQuantity, 0)),
    status: String(firstDefined(row.status, row.lineItemStatus, '-')),
  };
};

export const normalizeAllocationResponse = (body = {}) => {
  const payload = body?.data && !Array.isArray(body.data)
    ? body.data
    : body;
  const rows = Array.isArray(body)
    ? body
    : Array.isArray(body.data)
      ? body.data
      : firstDefined(payload.rows, payload.items, []);
  const safeRows = Array.isArray(rows) ? rows : [];

  return {
    rows: safeRows.map(row => normalizeAllocationRow(row)),
    count: asQuantity(firstDefined(
      payload.count,
      payload.totalCount,
      payload.total,
      safeRows.length
    )),
    summary: {
      reserved: asQuantity(payload.summary?.reserved),
      unallocated: asQuantity(payload.summary?.unallocated),
    },
  };
};

export const fetchStockAllocations = ({
  location,
  order,
  sku,
  fromDate,
  toDate,
  page,
  perPage,
}) => {
  const request = superagent
    .get(`${backendUrl}/inventory/stock-allocations`)
    .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
    .set('accept', 'json')
    .query({
      type: 'all',
      ...(location && location !== 'all' ? { location } : {}),
      ...(order ? { order } : {}),
      ...(sku ? { sku } : {}),
      ...(fromDate ? { fromDate } : {}),
      ...(toDate ? { toDate } : {}),
      page,
      perPage,
    });

  return request;
};
